<template>
	<div class="mc-exercise-frame">
		<!-- EXERCISE CONTENT (BY LAYOUT) -->
		<div class="mc-exercise-frame-content e2e-mc-output"
			 :class="showConsole ? ' mc-console-active' : ''">
			<slot></slot>
		</div>
		<!-- CONSOLE -->
		<div class="mc-exercise-frame-console"
			 :class="showConsole ? ' mc-console-active' : ''">
			<div class="container d-flex justify-content-center">
				<mc-console/>
			</div>
		</div>
		<!-- FOOTER -->
		<div class="mc-exercise-frame-footer d-flex justify-content-between align-items-end">
			<div class="small">
				<a href="https://mathcoach.htwsaar.de/" target="_blank">(C) MathCoach, htwsaar</a>
			</div>
			<div style="color: lightgray; overflow: hidden;" class="small">
                <span :style="{color: serverStatus.ok ? 'lightgray':'red'}"
					  :title="serverStatus.longMessage">
                    {{serverStatus.shortMessage}}
                </span>
			</div>
			<div> 
				<!-- LOGOUT -->
				<a class="btn btn-sm mc-footer-btn"
				   title="Aufgabe beenden"
				   :href="logoutUrl"
				   id="mc-footer-btn-logout">
					<i class="fa fa-sign-out" aria-hidden="true"></i>
				</a>
			</div>
		</div>

		<!-- BLOCK UI -->
		<block-ui/>
	</div>
</template>

<script>
	import McConsole from "./mc-console.vue";
	import BlockUi from "./block-ui.vue";

	export default {
		components: {
			McConsole,
			BlockUi
		}, 
		computed: {
			showConsole() {
				return this.$store.getters.showMcConsole;
			}, 
			logoutUrl() {
				return this.$store.state.logoutUrl;
			},
			serverStatus() {
				return this.$store.state.serverStatus;
			}
		}
	};
</script>

<style scoped>
	.mc-exercise-frame {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		min-width: 400px;
		min-height: 300px;
		overflow: hidden;
	}

	/*
	 * McConsole ist NICHT sichtbar (.mc-console-active ist NICHT gesetzt)
	 */
	.mc-exercise-frame-content {
		position: absolute;
		top: 0;
		bottom: 40px;
		right: 0;
		left: 0;
		padding: 5px 5px 5px 5px;
	}
	.mc-exercise-frame-console {
		display: none;
	}

	/*
	 * McConsole ist sichtbar (.mc-console-active ist gesetzt)
	 */
	.mc-exercise-frame-content.mc-console-active {
		bottom: 150px;
	}
	.mc-exercise-frame-console.mc-console-active {
		display: block;
		height: 110px;
		position: absolute;
		bottom: 40px;
		right: 0;
		left: 0;
		padding: 5px 5px 5px 5px;

		border-top-style: solid;
		border-top-width: 1px;
		border-top-color: lightgray;
	}

	.mc-exercise-frame-footer {
		height: 40px;
		position: absolute;
		bottom: 0;
		right: 0;
		left: 0;

		border-top-style: solid;
		border-top-width: 1px;
		border-top-color: lightgray;
	}

	.mc-footer-btn {
		margin: 5px 5px 5px 0px;
	}
</style>